<template>
    <div>
        <Panel
            :title="$t('Retry Profiles')"
            :add-button="$store.hasRight('DIAL_RIGHTS_ADD_REDDIAL_RETRY_PROFILES') ? $t('New Profile') : ''"
            :delete-button="selected.length > 0"
            :total-rows="items.length"
            :page="page"
            @delete="handleDelete"
            @input="openForm(-1)"
            @change="setPage"
        >
            <table id="retryprofiles_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Profile') }}</th>
                        <th style="width: 80px">{{ $t('Start') }}</th>
                        <th style="width: 80px">{{ $t('End') }}</th>
                        <th style="width: 80px">{{ $t('Attempts') }}</th>
                        <th
                            v-if="$store.hasRight('DIAL_RIGHTS_DELETE_REDDIAL_RETRY_PROFILES')"
                            class="td-checkbox"
                        ></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="profile in profiles" @click="(evt) => handleOpen(profile.profileId, evt)">
                        <td class="primary">
                            {{ profile.name }}
                        </td>
                        <td>{{ profile.startTime }}</td>
                        <td>{{ profile.endTime }}</td>
                        <td>{{ profile.maxAttempts }}</td>
                        <td v-if="$store.hasRight('DIAL_RIGHTS_DELETE_REDDIAL_RETRY_PROFILES')">
                            <cic-checkbox
                                :value="selected.indexOf(profile.profileId) !== -1"
                                @click="handleSelected(profile.profileId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <edit-retry-profile
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            :parameters="parameters"
            @blur="closePopup"
            @input="saveItem"
            @updateFieldValue="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import EditRetryProfile from './EditRetryProfile';
    import './styles/retryprofiles.scss';

    export default {
        name: 'RetryProfiles',
        components: {
            CicCheckbox,
            EditRetryProfile,
            Panel,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                parameters: {},
                page: 1,
                selected: [],
                totalRows: 0,
            };
        },
        computed: {
            profiles() {
                return this.items.slice((this.page - 1) * 20, this.page * 20);
            },
        },
        created() {
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('retryprofiles/delete', { profileIds: this.selected }, this.loadTable);
            },

            loadTable() {
                this.selected = [];
                this.closePopup();
                load('retryprofiles/get', {}, (response) => {
                    this.items = response.profiles;
                    this.parameters = response.parameters;
                    this.totalRows = response.totalRows;
                });
            },

            openForm(profileId) {
                if (profileId > 0) {
                    load('retryprofile/get', { profileId: profileId }, (response) => {
                        this.item = response.profile;
                    });
                } else {
                    this.item = {
                        profileId: null,
                        name: '',
                        maxAttempts: '',
                        maxAttemptsDaily: '',
                        startTime: '00:00',
                        endTime: '23:59',
                        maxAttemptsPerNumber: '',
                        unlimitedAttemptsPerNumber: true,
                        immediateDialNextOnFailure: false,
                    };
                    this.item.completionCodes = ['Answer Machine', 'Busy', 'Invalid Number', 'No Answer'].map((x) => ({
                        code: this.$t(x),
                        intervalType: 0,
                        intervalMS: 60,
                        intervalSessions: 1,
                        readOnly: true,
                        retryDate: null,
                        retryTime: null,
                        retryInPreviewMode: false,
                        rules: [],
                    }));
                    this.item.failureCompletionCodes = ['Answer Machine', 'Busy', 'Invalid Number', 'No Answer'].map(
                        (x) => ({
                            code: this.$t(x),
                            readOnly: true,
                        }),
                    );
                }
            },

            saveItem() {
                if (this.item.name.trim() === '') {
                    alert(this.$t('Name is a required field'));
                    return;
                }

                if (this.item.maxAttempts.toString().trim() === '') {
                    alert(this.$t('Number of call attempts is a required field'));
                    return;
                }

                if (this.item.maxAttemptsDaily.toString().trim() === '') {
                    alert(this.$t('Number of call attempts per day is a required field'));
                    return;
                }

                if (!this.item.unlimitedAttemptsPerNumber && this.item.maxAttemptsPerNumber.toString().trim() === '') {
                    alert(this.$t('Number of call attempts per number is a required field'));
                    return;
                }

                if (this.item.startTime.trim() === '' || this.item.endTime.trim() === '') {
                    alert(this.$t('Retry calls between is a required field'));
                    return;
                }

                const params = {
                    profileId: this.item.profileId,
                    name: this.item.name,
                    maxAttempts: this.item.maxAttempts,
                    maxAttemptsDaily: this.item.maxAttemptsDaily,
                    maxAttemptsPerNumber: this.item.maxAttemptsPerNumber,
                    unlimitedAttemptsPerNumber: this.item.unlimitedAttemptsPerNumber ? 1 : 0,
                    immediateDialNextOnFailure: this.item.immediateDialNextOnFailure ? 1 : 0,
                    startTime: this.item.startTime,
                    endTime: this.item.endTime,
                    completionCodes: JSON.stringify(this.item.completionCodes),
                    failureCompletionCodes: JSON.stringify(this.item.failureCompletionCodes),
                };
                save('retryprofile/update', params, this.loadTable);
            },
        },
    };
</script>
